var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("general-settings")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input-number", {
                    attrs: {
                      decimals: 0,
                      label: _vm.$ct("extra-bookyears-to-search"),
                    },
                    model: {
                      value: _vm.extraBookYearsToSearch,
                      callback: function ($$v) {
                        _vm.extraBookYearsToSearch = $$v
                      },
                      expression: "extraBookYearsToSearch",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }